var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuickBooks = function SvgQuickBooks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 23.9487C9.6001 28.1778 13.0705 31.6077 17.3532 31.6077H18.4607V28.7613H17.3532C14.666 28.7613 12.4798 26.6026 12.4798 23.9487C12.4798 21.2934 14.666 19.1347 17.3532 19.1347H20.0143V34.014C20.0143 35.5848 21.3028 36.8575 22.894 36.8575V16.2898H17.3532C13.0705 16.2898 9.6001 19.7182 9.6001 23.9487ZM30.647 16.2898H29.5394V19.1362H30.647C33.3342 19.1362 35.5204 21.2949 35.5204 23.9487C35.5204 26.604 33.3342 28.7627 30.647 28.7627H27.9859V13.8835C27.9859 12.3126 26.6974 11.04 25.1048 11.04V31.6077H30.647C34.9282 31.6077 38.4001 28.1793 38.4001 23.9487C38.4001 19.7211 34.9282 16.2898 30.647 16.2898Z",
    fill: "#2CA01C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuickBooks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/QuickBooks.25b1adc4.svg";
export { ForwardRef as ReactComponent };